module.exports = __webpack_public_path__ + "static/10-min-41a1a6a70eca140565f5124cd8205b0e.jpg";